import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import { getNotification, putNotification } from "api/notification";

const firebaseConfig = {
  apiKey: "AIzaSyAUkbRhWqyuUXFkLWUVgzdK3ShTFdVD_lA",
  authDomain: "notification-3a61d.firebaseapp.com",
  projectId: "notification-3a61d",
  storageBucket: "notification-3a61d.appspot.com",
  messagingSenderId: "854327711929",
  appId: "1:854327711929:web:05edfc0613d1d803cb6368",
  measurementId: "G-J2KHLVNV5C",
};

const firebaseApp = initializeApp(firebaseConfig);
const messaging = getMessaging(firebaseApp);

export const fetchToken = async (setTokenFound) => {
  try {
    const notification = await getNotification();
    const getTokenFirebase = localStorage.getItem("tokenFirebase");
    const permissionNotify = await Notification.requestPermission();

    if (permissionNotify === "granted") {
      const currentToken = await getToken(messaging, {
        vapidKey:
          "BCCsygsU7zhjs0zN1ZyRA1ojxVK78jTcKhHF1KIkEwLLM2c-OcIBJKRtjQkRlwv553dXkUQsByhBs68e7gx7Cgo",
      });

      if (
        notification?.data?.token !== getTokenFirebase &&
        Object.keys(notification?.data).filter(
          (key) => key !== "token" && notification.data[key]
        ).length > 0
      ) {
        putNotification({
          ...notification.data,
          token: currentToken ?? null,
        });
      }

      setTokenFound(!!currentToken);
      localStorage.setItem("tokenFirebase", currentToken ?? null);

      return {
        ...notification.data,
        token: currentToken ?? null,
      };
    }
  } catch (err) {
    console.log("Um erro ocorreu inesperadamente ", err);
  }
};

export const onMessageListener = () =>
  new Promise((resolve) => {
    onMessage(messaging, (payload) => {
      resolve(payload);
    });
  });

export { messaging, firebaseApp };
